export const MIGRATED_BATCH_REDIRECT_MESSAGE =
  "Migrated data cannot be redirected to Manage Data.";
export const MANAGE_DATA_PERMISSION_DENIED_MESSAGE =
  "You do not have permission to view the Manage Data review list.";
export const RECENTLY_VISITED_ROW_BACKGROUND = "#F2F4F7";

const TRUE_FLAG_VALUES = new Set(["true", "1", "yes"]);

export const isTruthyFlag = (value) =>
  value === true || TRUE_FLAG_VALUES.has(String(value).trim().toLowerCase());

export const isBlankBatchValue = (value) =>
  value === null || value === undefined || String(value).trim() === "";

export const normalizeMissingParameterNames = (value) => {
  const values = Array.isArray(value) ? value : String(value || "").split(",");

  return values.map((item) => String(item).trim()).filter(Boolean);
};
